export const FUNIL = ["tofu_mr", "tofu_aw", "mofu_aw", "mofu_mr", "bofu_mr", "bofu_hr"]

export const REGION = ["geral", "BR", "LAS"]

export const ALIANCE = [
   "NVIDIA",
   "NVIDIA GLOBAL",
   "INTEL DCF",
   "INTEL ZEUS",
   "INTEL RTGB",
   "INTEL KODIAK",
   "AMD CANAIS",
   "MICROSOFT MX",
   "MICROSOFT HX",
]

export const DATA = {
   "ADOBE ENTERPRISE": {
      produto: ["acrobatsign", "acrobatpro", "geral"],
   },
   BOAVISTA: {
      produto: ["e-card", "e-marketplace"],
   },
   BOWE: {
      produto: ["abm", "dg"],
   },
   HARPOON: {
      produto: ["geral"],
   },
   ITS: {
      produto: ["4hana", "grow", "muv", "onepage", "rise", "geral"],
   },
   LENOVO: {
      produtosDcg: [
         "EdgeAI",
         "AI Solutions (Inference)",
         "Hybrid AI",
         "Edge",
         "Serves/HCI",
         "Storage",
         "Canais",
         "CIO Playbook (NVIDIA)",
         "SSG-DWS",
         "SSG-AI-SERVICE",
         "SSG-SERVICE-DESK",
         "SSG- SUSTENTABILIDADE",
      ],
      regiao: ["BR", "LAS", "MEX", "NOLA", "SOLA"],
   },
   LINA: {
      produto: ["always-on", "lina-pay", "data-link", "jsr"],
   },
   OMID: {
      produto: ["cibersegurança", "data-centers", "omidcloud", "solucoes-ti"],
   },
   SKYONE: {
      produto: ["dados&ia-pmax", "dados&ia-search", "marca-search", "nuvem-search"],
   },
}
